import React from "react";
import {
  createStyles,
  Box,
  Stack,
  Text,
  Center,
  Image,
  Space,
  Group,
  Anchor,
  List,
  useMantineColorScheme,
  useMantineTheme,
} from "@mantine/core";
import AppLogo from "./components/AppLogo";

import { Link, useNavigate, useParams } from "react-router-dom";

function PrivacyPage({ children, ...otherProps }) {
  const { classes } = useStyles();
  const navigation = useNavigate();

  return (
    <Box className={classes.container} {...otherProps}>
      <Box className={classes.root}>
        <Box className={classes.grid}>
          <Box className={classes.section}>
            <Center px={50} pt={30} pb={10}>
              <Stack spacing={0} justify='center'>
                <Center>
                  <AppLogo variant="white" onClick={() => navigation("/")} sx={{ cursor: "pointer" }} />
                </Center>
              </Stack>
            </Center>
          </Box>

          <Space h={30} />
        </Box>
      </Box>

      <Box className={classes.containerTwo}>
        <Box className={classes.root}>
          <Box className={classes.grid}>
            <Box className={classes.section} mt={50}>
              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Privacy Policy
                </Text>
                <Text weight={400} size={18} fs='italic'>
                  Last Updated: January 07 2025
                </Text>
                <Text weight={400} size={18}>
                  This Privacy Policy explains how information is collected, used and
                  disclosed by "Sigmaly AI" with respect to user's access and use of our
                  service through the application (Referred to below as "Sigmaly AI").
                </Text>
              </Stack>
              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Information collection
                </Text>

                <Text weight={400} size={18} mt={10}>
                  When contacting us (e.g. via contact form or e-mail), personal data is
                  collected. Which data is collected when using a contact form can be seen
                  from the respective contact form in the app. This data is stored and
                  used exclusively for the purpose of answering your request or for
                  contacting you and the associated technical administration. The legal
                  basis for the processing of this data is our legitimate interest in
                  answering your request in accordance with Article 6 (1) (f) GDPR. If
                  your contact is aimed at concluding a contract, the additional legal
                  basis for processing is Art. 6 (1) (b) GDPR. Your data will be deleted
                  once your request has been processed. This is the case if it can be
                  inferred from the circumstances that the facts in question have been
                  finally clarified and provided that there are no legal storage
                  obligations to the contrary.
                </Text>
              </Stack>
              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Information usage
                </Text>
                <Text weight={400} size={18}>
                  Your information is used internally for the purposes described below:
                </Text>
                <List withPadding>
                  <List.Item>
                    <Text weight={400} size={18}>
                      to provide our services or information you request, and to process
                      and complete any transactions;
                    </Text>
                  </List.Item>
                  <List.Item>
                    <Text weight={400} size={18}>
                      to respond to your emails, submissions, questions, comments,
                      requests, and complaints and provide customer service;
                    </Text>
                  </List.Item>
                  <List.Item>
                    <Text weight={400} size={18}>
                      to analyze usage and trends with anonymous user data, and to improve
                      the quality of our service and user experience;
                    </Text>
                  </List.Item>
                  <List.Item>
                    <Text weight={400} size={18}>
                      to send you confirmations, updates, security alerts, and support and
                      administrative messages and otherwise facilitate your use of, and
                      our administration and operation of, our services;
                    </Text>
                  </List.Item>
                </List>
              </Stack>
              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Security
                </Text>
                <Text weight={400} size={18}>
                  The security of your Personal Information is important to us, but
                  remember that no method of transmission over the Internet, or method of
                  electronic storage is 100% secure. While we strive to use commercially
                  acceptable means to protect your Personal Information, we cannot
                  guarantee its absolute security.
                </Text>
              </Stack>
              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Service Providers
                </Text>
                <Text weight={400} size={18}>
                  We may employ third party companies and individuals to facilitate our
                  Service, to provide the Service on our behalf, to perform
                  Service-related services or to assist us in analyzing how our Service is
                  used. These third parties have access to your Personal Information only
                  to perform these tasks on our behalf and are obligated not to disclose
                  or use it for any other purpose.
                </Text>
              </Stack>
              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  Changes To This Privacy
                </Text>
                <Text weight={400} size={18}>
                  Policy We may update our Privacy Policy from time to time. We will
                  notify you of any changes by posting the new Privacy Policy on this
                  page. You are advised to review this Privacy Policy periodically for any
                  changes. Changes to this Privacy Policy are effective when they are
                  posted on this page.
                </Text>
              </Stack>
              <Stack spacing={0} justify='left'>
                <Text weight={600} size={26}>
                  How to Contact Us
                </Text>
                <Text weight={400} size={18}>
                  If you want to submit a request by email or if you have any other
                  questions about privacy or data protection at "Sigmaly AI", you can
                  contact us at{" "}
                  <Anchor href='mailto:privacy@sigmaly.app'>privacy@sigmaly.app</Anchor>
                </Text>
              </Stack>
            </Box>
            <Space h={30} />
          </Box>
        </Box>
      </Box>
      <Box className={classes.container}>
        <Box className={classes.root}>
          <Box className={classes.grid} mt={30}>
            <Box className={classes.sectionTwo}>
              <Text weight={400} size={16} align='left' sx={{ color: "#E5E5E7" }}>
                Made with ❤️ and ☕️ by Anatoli Niculeac<sup>©</sup> 2025
              </Text>
              <Group spacing={10} p={20} position='right'>
                <Anchor component={Link} to={"/support"} className={classes.link}>
                  <Text weight={400} size={16} align='left' sx={{ color: "#E5E5E7" }}>
                    Support
                  </Text>
                </Anchor>
                <Text weight={400} size={16} align='left' sx={{ color: "#E5E5E7" }}>
                  |
                </Text>
                <Anchor component={Link} to={"/terms"} className={classes.link}>
                  <Text weight={400} size={16} align='left' sx={{ color: "#E5E5E7" }}>
                    Terms of use
                  </Text>
                </Anchor>
                <Text weight={400} size={16} align='left' sx={{ color: "#E5E5E7" }}>
                  |
                </Text>
                <Anchor component={Link} to={"/privacy"} className={classes.link}>
                  <Text weight={400} size={16} align='left' sx={{ color: "#E5E5E7" }}>
                    Privacy Policy
                  </Text>
                </Anchor>
                <Text weight={400} size={16} align='left' sx={{ color: "#E5E5E7" }}>
                  |
                </Text>

                <Anchor component={Link} to={"/contact"} className={classes.link}>
                  <Text weight={400} size={16} align='left' sx={{ color: "#E5E5E7" }}>
                    Contact
                  </Text>
                </Anchor>
              </Group>
              <Space h={10} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default PrivacyPage;

const useStyles = createStyles((theme) => ({
  root: {
    height: "100%",
    width: "100%",
    overflowX: "hidden",

    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  },

  container: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "100%",

    "@media (max-width: 768px)": {
      width: "100%",
    },
    width: "100%",
    height: "100%",

    backgroundColor: "#5856D6",
  },
  containerTwo: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "100%",

    "@media (max-width: 768px)": {
      width: "100%",
    },
    width: "100%",
    height: "100%",
    backgroundColor: "#F5F5F7",
  },

  section: {
    maxWidth: 980,
    // width: '100%',
    marginLeft: "auto",
    marginRight: "auto",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "1fr",
    gridGap: "1em",
    gap: 25,
    alignItems: "center",
    paddingLeft: 25,
    paddingRight: 25,
  },

  sectionTwo: {
    maxWidth: 980,
    // width: '100%',
    marginLeft: "auto",
    marginRight: "auto",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr",
    gridGap: "1em",
    gap: "1em",
    alignItems: "center",
    paddingLeft: 25,
    paddingRight: 25,
  },
  grid: {
    display: "grid",
    width: "100%",
    height: "100%",

    gridTemplateColumns: "auto",
    gridTemplateRows: "auto",

    "@media (max-width: 1023px)": {
      gridTemplateColumns: "auto",
      justifyContent: "stretch",
    },

    "@media (min-width: 1600px)": {
      gridTemplateColumns: "auto",
      gridTemplateRows: "auto",
      WebkitTransition: "300ms",
    },
  },
  flex: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",

    gap: 20,
  },
  //   grid: {
  //     display: 'grid',
  //     gridTemplateColumns: '1fr auto 1fr',
  //     gridTemplateRows: 'auto',
  //     justifyContent: 'space-between',

  //     '@media (max-width: 425px)': {
  //       gridTemplateColumns: '1fr',
  //       gridTemplateRows: 'auto',
  //       justifyContent: 'center',
  //       alignContent: 'center',
  //       justifyItems: 'center',
  //     },
  //   },

  link: {
    whiteSpace: "nowrap",
    textDecoration: "none",

    ":last-child": {
      borderRight: "none",
    },

    webkitTransition: "opacity 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)",
    transition: "opacity 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)",
    // WebkitTapHighlightColor: 'rgba(0,0,0,0)',
    // outlineOffset: '-7px',

    ":hover": {
      transition: "0.5s color",
      textDecoration: "none",
      fontWeight: 600,
    },
    transition: "0.5s color",
  },
}));
